import { FC } from 'react'
import { Spin } from '@vivaldis/antd-ui'

export const LoadingState: FC = () => {
  return <Spin />
}
